import React, { useMemo } from 'react'

import { useQuery } from '@apollo/client'

import { GET_CURRENT_CUSTOMER_RESERVATIONS } from 'Const'

import { QueryState } from '../../components/QueryState'

import { ReservationCard } from './Card'
import { Reservation } from './types'
import { groupReservations } from './utils'

export const ReservationsTab: React.FC = () => {
  const { data, loading, error } = useQuery(GET_CURRENT_CUSTOMER_RESERVATIONS)

  const reservations: Reservation[] = useMemo(() => data?.currentCustomer?.reservations ?? [], [data])
  const { upcoming, history } = useMemo(() => groupReservations(reservations), [reservations])

  return (
    <div className="user-profile-panel user-profile-panel_enter">
      <h2 className="user-profile-section__title">Reservations</h2>
      <QueryState
        emptyLabel="You don't have any reservations yet"
        error={error}
        isEmpty={!loading && !error && reservations.length === 0}
        loading={loading}
        loadingLabel="Loading your reservations…"
      >
        <>
          {upcoming.length > 0 && (
            <section className="user-profile-section">
              <div className="user-profile-section__header">
                <h2 className="user-profile-section__title">Upcoming Reservations</h2>
              </div>
              <div className="user-profile-reservation-list">
                {upcoming.map((reservation) => (
                  <ReservationCard key={reservation.id} reservation={reservation} />
                ))}
              </div>
            </section>
          )}

          {history.length > 0 && (
            <section className="user-profile-section">
              <div className="user-profile-section__header">
                <h2 className="user-profile-section__title">Past Reservations</h2>
              </div>
              <div className="user-profile-reservation-list">
                {history.map((reservation) => (
                  <ReservationCard key={reservation.id} reservation={reservation} />
                ))}
              </div>
            </section>
          )}
        </>
      </QueryState>
    </div>
  )
}
